@if (columns().length > 0) {
  <div class="w-full">
    <table mat-table class="table-skeleton w-full" [dataSource]="dataSource">
      @for (col of columns(); track $index) {
        <ng-container matColumnDef="{{ col.field }}">
          <th mat-header-cell *matHeaderCellDef class="capitalize" [style.width]="col.width">
            <div class="flex items-center">
              @if (col.isCheckbox) {
                <mat-checkbox> </mat-checkbox>
              }
              {{ col.label | translate }}
            </div>
          </th>
          <td mat-cell *matCellDef="let row" [style.width]="col.width">
            @if (col.isAvatar) {
              <div class="flex items-center gap-2">
                <xemex-skeleton-block
                  class="flex-none"
                  [width]="'36px'"
                  [height]="'36px'"
                  [borderRadius]="'50%'"
                  [color]="'primary'"
                ></xemex-skeleton-block>
                <xemex-skeleton-block
                  [width]="'70%'"
                  [height]="'16px'"
                  [color]="'primary'"
                ></xemex-skeleton-block>
              </div>
            } @else if (col.isCheckbox) {
              <div class="flex items-center">
                <xemex-skeleton-block
                  class="mx-2.5 shrink-0"
                  [width]="'20px'"
                  [height]="'20px'"
                  [borderRadius]="'4px'"
                ></xemex-skeleton-block>
                <xemex-skeleton-block
                  class="flex-none"
                  [width]="'70%'"
                  [height]="'16px'"
                ></xemex-skeleton-block>
              </div>
            } @else {
              <xemex-skeleton-block [width]="'60%'" [height]="'16px'"></xemex-skeleton-block>
            }
          </td>
        </ng-container>
      }

      <tr mat-header-row *matHeaderRowDef="columnDisplay"></tr>
      <tr mat-row *matRowDef="let row; columns: columnDisplay"></tr>
    </table>
  </div>
}
